<script setup>
import { authStore } from '@/store/auth'

const { signIn } = authStore()
const { data, isDialogVisible, msgDialog } = storeToRefs(authStore())

const userLogin = ref({
  username: data.value?.user?.USER_username,
  password: '',
})

const isPasswordVisible = ref(false)
const loading = ref(false)

const refresh = async () => {
  loading.value = true
  try {
    await signIn(userLogin.value, {}, true)
  } finally {
    loading.value = false
  }
}
</script>


<template>
  <Loader v-model="loading" />
  <VDialog
    v-model="isDialogVisible"
    max-width="600"
    persistent
  >
    <!-- Dialog Content -->
    <VCard
      :title="$t('Login')"
      :subtitle="$t(msgDialog)"
    >
      <VCardText>
        <VRow>
          <VCol cols="12">
            <AppTextField
              v-model="userLogin.password"
              :label="$t('Password')"
              autocomplete="on"
              placeholder="············"
              :type="isPasswordVisible ? 'text' : 'password'"
              :append-inner-icon="isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
              @click:append-inner="isPasswordVisible = !isPasswordVisible"
            />
          </VCol>
        </VRow>
      </VCardText>

      <VCardText class="d-flex justify-end flex-wrap gap-3">
        <VBtn @click="refresh">
          {{ $t('Login') }}
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>
</template>
